import React, { FC } from 'react';

import { AccountActions } from '../../components/AccountActions';
import { Content } from '../../components/shared/Content';
import { useAccount } from '../../fetchHooks/useAccount';
import useAccountId from '../../hooks/queryparams/useAccountId';

import './PaymentActions.scss';

const PaymentActions: FC = () => {
    const accountId = useAccountId();
    const { data: account } = useAccount(accountId);

    return (
        <Content className="payments-actions-widget">
            <AccountActions account={account} withCrossborder />
        </Content>
    );
};

export default PaymentActions;
